import { Divider } from 'antd';

import SubFormAdditionalInformation from './SubForms/AdditionalInformation';
import InspectionRequirement from './SubForms/InspectionRequirement';
import Report from './SubForms/ReportDetail';
import SupplierAndFactory from './SubForms/SelectFactory';
import { Field } from 'formik';
import Panel from 'app/components/Layout/Panel';

const ReviewAndSubmit = () => {
  return (
    <Panel title="1. Review & Submit">
      <Field name="inspectionRequirement">
        {({ field }) => {
          return <InspectionRequirement value={field.value} />;
        }}
      </Field>
      <Divider />
      <Field name="inspectionPOItems">
        {({ field }) => {
          return <Report value={field.value} />;
        }}
      </Field>
      <Divider />

      <SupplierAndFactory />
      <Divider />
      <Field name="additionalInformation">
        {({ field }) => {
          return <SubFormAdditionalInformation value={field.value} />;
        }}
      </Field>
    </Panel>
  );
};

export default ReviewAndSubmit;
